import $ from 'jquery';
import React from 'react';
import {observer} from 'mobx-react';
import Modal from '../../Modal';
import {I18n} from '../../i18n/i18n';
import AddReportInstructionToQueueButton from './AddReportInstructionToQueueButton';
import {stylesheet} from 'typestyle';
import {Stores} from '../../inject';

@observer
export default class ReportGenerationModal extends React.Component<Stores<'store'>, any> {
    public componentDidMount() {
        const neededCurrencies = this.props.store.lineDiagramStore.getChannelCurrenciesOfRequestedDiagramItems();
        this.props.store.odtExportStore.reportTargetCurrency = neededCurrencies.length > 0 ? neededCurrencies[0] : '';
    }

    public closeModal = () => {
        this.props.store.odtExportStore.clear();
    };

    public updateModalHeaderText = (text) => {
        this.props.store.odtExportStore.reportModalHeader = text;
    };

    public updateModalFooterText = (text) => {
        this.props.store.odtExportStore.reportModalFooter = text;
    };

    public render() {
        this.props.store.selectorTableStore.updateTable;
        const {reportTargetCurrency, reportModalFooter, reportModalHeader, reportBuildInstructions} = this.props.store.odtExportStore;
        const {getAllChannelCurrencies} = this.props.store.channelStore;
        return (
            <Modal
                store={this.props.store}
                modalHeader={
                    <h5 className="modal-title">
                        <I18n i18nKey="table:generateReportButtonTitle" />
                    </h5>
                }
                onModalClose={this.closeModal}
                modalBody={
                    <div>
                        <p style={{marginBottom: 5}}>
                            <I18n i18nKey="currency.targetCurrency" />
                        </p>
                        <select
                            className={reportModalCss.currencySelector}
                            value={reportBuildInstructions.length > 0 ? reportBuildInstructions[0].targetCurrency : reportTargetCurrency}
                            disabled={reportTargetCurrency !== '' && reportBuildInstructions.length > 0}
                            onChange={(e) => (this.props.store.odtExportStore.reportTargetCurrency = e.currentTarget.value)}>
                            {getAllChannelCurrencies().map((channelName) => (
                                <option key={channelName} value={channelName}>
                                    {channelName}
                                </option>
                            ))}
                        </select>
                        <p style={{marginBottom: 5}}>
                            <I18n i18nKey="table:textAfterReportHeading" />
                        </p>
                        <ObservedTextArea value={reportModalHeader} textarea_update_function={this.updateModalHeaderText} />
                        <br />
                        <p style={{marginBottom: 5}}>
                            <I18n i18nKey="table:textAfterReportAndTable" />
                        </p>
                        <ObservedTextArea value={reportModalFooter} textarea_update_function={this.updateModalFooterText} />
                    </div>
                }
                modalFooter={<AddReportInstructionToQueueButton store={this.props.store} />}
            />
        );
    }
}

class ObservedTextArea extends React.Component<any, any> {
    public textAreaContentChanged(e) {
        const $target = $(e.currentTarget);
        this.props.textarea_update_function($target.val());
    }

    public render() {
        return (
            <textarea
                className="form-control"
                style={{borderRadius: 2}}
                onChange={this.textAreaContentChanged.bind(this)}
                defaultValue={this.props.value}
            />
        );
    }
}

const reportModalCss = stylesheet({
    currencySelector: {
        height: 30,
        paddingLeft: 5,
        paddingRight: 5,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/ReportGenerationModal.tsx